import React from 'react';

import { DetailsProps, TopBar } from '../details/DetailsTopBar';
import { useDialogState } from '../dialog/useDialogState';

export function DialogTopBar({ loading, children }: DetailsProps): React.ReactElement {
  const [, setDialogState] = useDialogState();
  const handleClose = (): void => {
    setDialogState(null);
  };
  return <TopBar loading={loading} children={children} onClose={handleClose} />;
}
